/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-referral-payment.reducer';

export const ParamedicReferralPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicReferralPaymentEntity = useAppSelector(state => state.paramedicReferralPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicReferralPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.detail.title">ParamedicReferralPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.id}</dd>
          <dt>
            <span id="payment">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.payment">Payment</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.payment}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.timestampEntry}</dd>
          <dt>
            <span id="referralChargeType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.referralChargeType">Referral Charge Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.referralChargeType}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.modifiedByID}</dd>
          <dt>
            <span id="emergencyHike">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.emergencyHike">Emergency Hike</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.emergencyHike}</dd>
          <dt>
            <span id="hishRiskHike">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.hishRiskHike">Hish Risk Hike</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralPaymentEntity.hishRiskHike}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.doctor">Doctor</Translate>
          </dt>
          <dd>{paramedicReferralPaymentEntity.doctor ? paramedicReferralPaymentEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.hospital">Hospital</Translate>
          </dt>
          <dd>{paramedicReferralPaymentEntity.hospital ? paramedicReferralPaymentEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.scheme">Scheme</Translate>
          </dt>
          <dd>{paramedicReferralPaymentEntity.scheme ? paramedicReferralPaymentEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.paramedic">Paramedic</Translate>
          </dt>
          <dd>{paramedicReferralPaymentEntity.paramedic ? paramedicReferralPaymentEntity.paramedic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-referral-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-referral-payment/${paramedicReferralPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicReferralPaymentDetail;
